/* eslint-disable no-restricted-syntax -- 도메인 산재 색상 (1~2건/색) — 디자인 시스템 토큰화 효율 < 50%, 별도 디자인 정리 plan으로 분리 */
import { style, keyframes } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';
import { mobile, reducedMotion } from '@/shared/ui/theme';

export const cursorBlink = keyframes({
  '0%, 100%': { opacity: '1' },
  '50%': { opacity: '0' },
});

export const hologramHeader = style({
  padding: '16px 24px 12px',
  borderBottom: `1px solid ${vars.surface.highlight.strong}`,
  position: 'relative',
  overflow: 'hidden',
  // 제목 크기의 기준 — 폰에서 틀이 좁아지면 WELCOME :: AXIOM 이 함께 작아진다(mainTitle 조각들)
  containerType: 'inline-size',
  // 폰 — 머리 영역이 틀 높이의 절반 가까이를 먹어 화면이 꽉 차 보인다. 여백부터 줄인다
  '@media': {
    [mobile]: { padding: '12px 16px 10px' },
  },
});

export const headerScanLine = style({
  display: 'none',
});

export const headerContent = style({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '12px',
  '@media': {
    [mobile]: { marginBottom: '8px' },
  },
});

export const logoContainer = style({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '12px',
  '@media': {
    [mobile]: { marginBottom: '8px' },
  },
});

export const logo = style({
  width: '72px',
  height: '72px',
  objectFit: 'contain',
  filter: `drop-shadow(0 0 8px ${vars.bright.primary.glow}) drop-shadow(0 0 20px ${vars.surface.highlight.strong}) drop-shadow(0 0 12px ${vars.opacityScale.warningAmber.moderate})`,
  opacity: 0.9,
  '@media': {
    [mobile]: { width: '52px', height: '52px' },
  },
});

export const systemDesignation = style({
  fontFamily: vars.typography.fontFamily.mono,
  fontSize: vars.typography.fontSize.xs,
  letterSpacing: '0.15em',
  // 폰 — 자간을 좁혀 SYS.GATE 줄이 두 줄로 접히지 않게 한다
  '@media': {
    [mobile]: { letterSpacing: '0.06em' },
  },
});

export const designationBracket = style({ color: vars.surface.border.glow });
export const designationCode = style({
  color: vars.bright.secondary.default,
  textShadow: `0 0 10px ${vars.bright.secondary.glow}`,
});
export const designationSeparator = style({
  color: vars.bright.textHighlight.scenario,
  margin: '0 2px',
});
export const designationModule = style({ color: vars.bright.primary.light });
export const designationVersion = style({ color: 'rgba(100, 140, 200, 0.88)', marginLeft: '4px' });

export const systemStatus = style({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
});

export const statusDot = style({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  background: vars.bright.status.success,
  boxShadow: `0 0 8px ${vars.bright.status.success}`,
});

export const statusText = style({
  fontFamily: vars.typography.fontFamily.mono,
  fontSize: vars.typography.fontSize['2xs'],
  color: vars.bright.status.success,
  letterSpacing: '0.2em',
  textShadow: `0 0 8px ${vars.opacityScale.successGreen.intense}`,
  '@media': {
    [mobile]: { letterSpacing: '0.1em' },
  },
});

export const mainTitle = style({
  fontFamily: vars.typography.fontFamily.display,
  fontSize: vars.typography.fontSize['2xl'],
  fontWeight: vars.typography.fontWeight.bold,
  margin: '0 0 10px 0',
  display: 'flex',
  alignItems: 'baseline',
  gap: '8px',
  letterSpacing: vars.typography.letterSpacing.tight,
  '@media': {
    [mobile]: { margin: '0 0 6px 0' },
  },
});

export const titleGlow = style({
  color: vars.bright.secondary.default,
  // 원래 크기와 폭 비례 중 작은 쪽 — 제목 원래 폭(약 294px)을 기준 360 으로 나눈 비율(좁은 틀에서 틀 폭을 다 채우지 않게)
  fontSize: `min(${vars.typography.fontSize.lg}, 5.56cqi)`,
  fontFamily: vars.typography.fontFamily.mono,
  fontWeight: vars.typography.fontWeight.semibold,
  letterSpacing: '0.12em',
  textShadow: `0 0 20px ${vars.bright.primary.glow}, 0 0 40px ${vars.bright.primary.glow}`,
});

export const titleDivider = style({
  color: vars.bright.textHighlight.scenario,
  fontSize: `min(${vars.typography.fontSize.xl}, 6.67cqi)`,
});

export const titleText = style({
  color: vars.typography.textColor.primary,
  fontFamily: vars.typography.fontFamily.display,
  fontSize: `min(${vars.typography.fontSize['3xl']}, 10cqi)`,
  letterSpacing: '0.08em',
  textShadow: `0 0 20px ${vars.bright.primary.glow}, 0 0 40px ${vars.surface.highlight.strong}`,
});

export const scenarioTag = style({
  fontFamily: vars.typography.fontFamily.primary,
  fontWeight: vars.typography.fontWeight.semibold,
  fontSize: vars.typography.fontSize.sm,
  color: vars.bright.textHighlight.scenario,
  letterSpacing: vars.typography.letterSpacing.expanded,
  marginBottom: '6px',
  textShadow: `0 0 15px ${vars.opacityScale.goldWarm.veryStrong}`,
});

export const tagBracket = style({ color: vars.opacityScale.goldWarm.veryStrong });
export const tagText = style({ color: vars.bright.textHighlight.scenario });
export const tagCursor = style({
  animation: `${cursorBlink} 1s step-end infinite`,
  '@media': {
    [reducedMotion]: { animation: 'none' },
  },
});

export const subtitle = style({
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: vars.typography.fontSize.base,
  fontWeight: vars.typography.fontWeight.semibold,
  color: vars.typography.textColor.secondary,
  margin: '0',
  letterSpacing: vars.typography.letterSpacing.wide,
  '@media': {
    [mobile]: { fontSize: vars.typography.fontSize.sm },
  },
});
